import { Button, Typography, Rating, Box } from "@mui/material";
import React from "react";
import { Appointment } from "../../../../context/appContext";
import CancelAppointmentDialog from "./cancelAppointmentDialog";
import CancelAppointmentButton from "./cancelAppointmentButton";
import { AppointmentsParticipantContext } from "../context/appointmentsParticipantContext";
import { IRating } from "../interface/iRating";
import getStarColor from "../../../../functions/getStarColor";

const RenderAppointmentOperation = ({
  appointment,
}: {
  appointment: Appointment;
}): React.JSX.Element => {
  const {
    setRating,
  }: {
    setRating: React.Dispatch<React.SetStateAction<IRating>>;
  } = React.useContext(AppointmentsParticipantContext);

  const [reason, setReason] = React.useState<string>("");
  const [openCancelDialog, setOpenCancelDialog] =
    React.useState<boolean>(false);

  const handleCloseCancelDialog = (): void => {
    setOpenCancelDialog(false);
    setReason("");
  };

  // appointment was missed
  if (appointment.status === "V")
    return (
      <Typography
        variant="body2"
        color="initial"
        sx={{
          fontWeight: "bold",
          textAlign: "center",
        }}
      >
        Sie haben diesen Termin versäumt
      </Typography>
    );

  // appointment was cancelt by the system (Kulanz)
  if (appointment.status === "K")
    return (
      <Typography
        variant="body2"
        color="initial"
        sx={{
          fontWeight: "bold",
          textAlign: "center",
        }}
      >
        Dieser Termin wurde aus Kulanz storniert
      </Typography>
    );

  if (
    !appointment.meta.stornoPossible &&
    !appointment.meta.past &&
    !appointment.meta.today
  )
    return (
      <Typography
        variant="body2"
        color="initial"
        sx={{
          fontWeight: "bold",
          textAlign: "center",
        }}
      >
        Dieser Termin kann nicht mehr storniert werden
      </Typography>
    );

  return (
    <React.Fragment>
      {/* Renders the cancel button if cancelation is possible */}
      {appointment.meta.stornoPossible && (
        <CancelAppointmentButton setOpenCancelDialog={setOpenCancelDialog} />
      )}

      {/* Renders the "to coaching button" if the appointment is today */}
      {appointment.meta.today && !appointment.meta.past && (
        <Button
          href={`${appointment.href}`}
          target="_blank"
          fullWidth
          variant="contained"
          color="secondary"
        >
          Zum Coaching
        </Button>
      )}

      {/* Renders the dialog for canceling the appointment */}
      <CancelAppointmentDialog
        openCancelDialog={openCancelDialog}
        handleCloseCancelDialog={handleCloseCancelDialog}
        appointment={appointment}
        reason={reason}
        setReason={setReason}
      />

      {/* Render a star view for an already rated appointment */}
      {appointment.meta.past &&
        appointment.meta.rating !== null &&
        appointment.meta.rating !== undefined && (
          <Box sx={{ textAlign: "center" }}>
            <Typography
              variant="caption"
              color="initial"
              sx={{
                fontWeight: "bold",
              }}
            >
              Ihre Bewertung
            </Typography>

            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
                gap: 1,
              }}
            >
              <Rating
                precision={0.5}
                readOnly
                name="size-large"
                defaultValue={2}
                size="medium"
                value={appointment.meta.rating.averageRating}
                sx={{
                  color: getStarColor(appointment.meta.rating.averageRating),
                }}
              />

              <Typography
                variant="body2"
                color="initial"
                sx={{
                  fontWeight: "bold",
                  textAlign: "center",
                }}
              >
                {appointment.meta.rating.averageRating}
              </Typography>
            </Box>
          </Box>
        )}

      {/* Renders the rating button if the appointment is not ratet and in the past */}
      {new Date(appointment.date) >= new Date("2025-05-01") &&
        appointment.meta.past &&
        appointment.meta.rating === null && (
          <Button
            fullWidth
            variant="contained"
            color="secondary"
            onClick={() =>
              setRating({
                open: true,
                appointment: appointment,
              })
            }
          >
            Bewerten
          </Button>
        )}
    </React.Fragment>
  );
};

export default RenderAppointmentOperation;
